import React, { Component, Fragment } from 'react'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import { FooterState } from 'ducks/footer/types'
import { Modal } from 'components/UI/Modal'
import { Button } from 'components/UI/Button'
import packageJson from '../../../../package.json'

class Footer extends Component<Props, {}> {
  state = {
    showModal: false,
    modalContent: ''
  }

  onShowModal = (content: string) =>
    this.setState({ showModal: true, modalContent: content })

  onCloseModal = () => this.setState({ showModal: false })

  showTerms = () => {
    this.onShowModal(this.props.term.htmlDocument)
  }

  openInNewTab = () => {
     const newWindow = window.open("https://www.continuumhealthtech.com", '_blank', 'noopener,noreferrer')
     if (newWindow) newWindow.opener = null
  }

  showPrivacyPolicy = () => {
    this.onShowModal(this.props.privacyPolicy.htmlDocument)
  }
  render() {
    const { patientSupportPhone, technicalSupportPhone } = this.props.phones

    return (
      <Fragment>
        <Modal
          modal={{
            title: '',
            content: (
              <Scroll
                dangerouslySetInnerHTML={{ __html: this.state.modalContent }}
              />
            ),
            footer: (
              <Fragment>
                <Button variant={'text'} onClick={this.onCloseModal}>
                  Cancel
                </Button>
              </Fragment>
            )
          }}
          isOpen={this.state.showModal}
        />
        <FooterWrap>
          <Container>
            <Row>
              <Col xl={6} md={12}>
                <FooterList>
                  <FooterItem>
                    Contact Us: {patientSupportPhone}
                  </FooterItem>
                </FooterList>
              </Col>
              <Col xl={6} md={12}>
                <FooterList align={'left'}>
                  <FooterItem clickable={true} onClick={this.showTerms}>
                    Terms of Service
                  </FooterItem>
                  <FooterItem clickable={true} onClick={this.showPrivacyPolicy}>
                    Privacy Policy
                  </FooterItem>
                </FooterList>
              </Col>
            </Row>
            <Row>
              <Col xl={6} md={12}>
                <FooterList>
                  <FooterItem  clickable={true} onClick={this.openInNewTab}>© Continuum Health Technologies</FooterItem>
                </FooterList>
              </Col>
              <Col xl={6} md={12}>
                <FooterList align={'left'}>
                  <VersionBlock>version: {packageJson.version}</VersionBlock>
                </FooterList>
              </Col>
            </Row>
          </Container>
        </FooterWrap>
      </Fragment>
    )
  }
}

interface Props {
  phones: FooterState
  privacyPolicy: any
  term?: any
}

export default Footer

const FooterWrap = styled.div.attrs(() => ({
  className: 'footer'
}))``

interface FooterListProps {
  readonly align?: string
}

interface FooterItemProps {
  onClick?: () => void
  clickable?: boolean
}

const FooterList = styled.ul<FooterListProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${props => props.align === 'left' && 'flex-end'};
  ${media.md``}
`

const FooterItem = styled.li<FooterItemProps>`
  color: #89919c;
  list-style: none;
  font-size: 14px;
  line-height: 18px;
  padding-right: 30px;
  margin: 10px 0;

  :last-child {
    padding-right: 0;
  }
  cursor: ${props => (props.clickable ? 'pointer' : 'unset')};
`

const Scroll = styled.div`
  display: block;
  //width: 350px;
  height: 400px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  line-height: normal;
`
const VersionBlock = styled.div`
  color: #89919c;
  list-style: none;
  font-size: 14px;
  line-height: 18px;
  padding-right: 30px;
  margin: 10px 0;
  //align-self: flex-end;
`
// justify-content: space-between;
// flex-direction: row;
